import { render, staticRenderFns } from "./product-catalogue.vue?vue&type=template&id=7d1288e8"
import script from "./product-catalogue.vue?vue&type=script&lang=js"
export * from "./product-catalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports